import React from 'react';
import classes from './BuildControl.css'

const buildControl = (props) => {
  let removeControllerClass = [classes.controller];
  let addControllerClass = [classes.controller];
  let addDisabled = false;
  let removeDisabled = false;
  if (props.number === 0) {
    removeControllerClass.push(classes.disabled);
    removeDisabled = true;
  } else if (props.number >= 5) {
    addControllerClass.push(classes.disabled)
    addDisabled = true;
  }

  if (props)

    return (
      <div className={classes.Wrapper}>
        <div className={classes.BuildControl}>
          <p>{props.label}</p>
          <div className={classes.PlusMinus}>
            <p className={removeControllerClass.join(' ')} onClick={removeDisabled ? null : props.removeIngredient}>-</p>
            <p className={classes.controlNumber}><strong>{props.number}</strong></p>
            <p className={addControllerClass.join(' ')} onClick={addDisabled ? null : props.addIngredient}>+</p>
          </div>
        </div>
      </div>
    )
}



export default buildControl;


// WEBPACK FOOTER //
// ./src/components/Burger/BuildControls/Build Control/BuildControl.jsx